// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3KRsb","Label":"Input_Label__bAAe-","InputElement":"Input_InputElement__eCtFE","Invalid":"Input_Invalid__1VdI3"};